<template>
  <div class="content-box">
    <div class="element-wrapper pb-0">
      <div class="element-header">
        <div class="row">
          <div class="col-md-8 mr-auto">
            <h3 class>Transações do Pedido #{{pedido.idPedidoVindi}}</h3>
          </div>
          <div class="col-auto">
            <b-button @click="voltar">Voltar</b-button>
          </div>
          <div class="col-auto">
            <b-button :download="`transacoes-${pedido.idPedidoVindi}-${empresa.name}.xls`"
                      :href="`${baseURL}/api/saude/fatura-xls/${pedido._id}?idEmpresa=${empresa._id}&idPedido=${pedido._id}`">
              <i class="fas fa-file-excel"></i> Exportar
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-end mb-2" v-if="pedido.formadePagamento === 'carne'">
      <div class="col-auto">
        <b-button @click="enviarCarnePorEmail(pedido.idPedidoVindi)">
          <i class="far fa-envelope"></i>
          Enviar Carnê por email
        </b-button>
      </div>
      <div class="col-auto">
        <b-button @click="enviarCarnePorWhatsapp(pedido.idPedidoVindi)">
          <i class="fab fa-whatsapp"></i>
          Enviar Carnê por Whatsapp
        </b-button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-card>
          <table class="table">
            <thead>
            <th>Nº Parcela</th>
            <th>Valor Fatura</th>
            <th>Valor Pagamento</th>
            <th>Valor Dr.Achei</th>
            <th>Total Taxa Operação</th>
            <th>Valor {{ empresa.name }}</th>
            <th>Forma de pagamento</th>
            <th>Data de vencimento da fatura</th>
            <th>Data de vencimento da cobrança</th>
            <th>Data do pagamento</th>
            <th>Data do envio</th>
            <th>Atendido Por</th>
            <th>Status</th>
            <th></th>
            </thead>
            <tbody>
            <tr v-for="fatura in this.transacoes" :key="fatura._id">
              <td>{{fatura.parcela}}</td>
              <td>{{fatura.valorFatura | money}}</td>
              <td>{{fatura.valorPagoFatura | money}}</td>
              <td>{{fatura.valorDrachei | money}}</td>
              <td>{{fatura.taxaOperacaoTotal | money}}</td>
              <td>{{fatura.valorEmpresa | money}}</td>
              <td>{{fatura.formaPagamento}}</td>
              <td>{{formataData(fatura.dataVencimento)}}</td>
              <td>{{formataData(fatura.dataVencimento)}}</td>
              <td>{{formataData(fatura.dataPagamento)}}</td>
              <td>{{formataData(fatura.dataEnvio)}}</td>
              <td>{{fatura.enviadoPor}}</td>
              <td>{{traduzirStatusPagamento(fatura)}}</td>
              <td>
                <b-button variant="light" title="Exibir Boleto" target="_blank" :href="fatura.urlBoleto" v-if="fatura.urlBoleto">
                  <i class="fa fa-file-pdf"></i> Boleto
                </b-button>
                <b-button variant="light" title="Enviar Boleto via Whatsapp" target="_blank" @click="enviarBoletoWhatsapp(fatura.urlBoleto,fatura.dataVencimento)" v-if="fatura.urlBoleto">
                  <i class="fab fa-whatsapp"></i> Enviar Boleto via Whatsapp
                </b-button>
                <b-button @click="enviarBoletoPorEmail(fatura)" v-if="!isVencida(fatura) && !fatura.dataPagamento" variant="light" title="Atualizar vencimento">
                  <i class="far fa-envelope"></i> Enviar boleto por email
                </b-button>
              </td>
            </tr>
            </tbody>
          </table>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  async created(){
    const id = this.$route.query.id;

    const responsePedido = await axios.get(`/api/saude/${id}`);
    this.pedido = responsePedido.data;

    const responseTransacoes = await axios.get(`/api/saude/fatura/${this.pedido._id}?idEmpresa=${this.empresa._id}`);
    this.transacoes = responseTransacoes.data;
  },
  data(){
    return {
      pedido: {},
      transacoes:[],
      ptBR: ptBR,
      disabledDates: {
        days: [6, 0],
        to: new Date()
      },
      dataVencimento: null,
      fatura: null
    }
  },
  computed: {
    empresa() {
      return this.$store.getters.empresa;
    },
    isAdministrador() {
      return this.$store.getters.isAdministrador;
    },
    baseURL() {
      return axios.defaults.baseURL;
    }
  },
  methods: {
    showModalAtualizarDataVencimento(fatura) {
      // eslint-disable-next-line
      console.log('FATURA', fatura);
      this.fatura = fatura;
      this.$nextTick(() => this.$bvModal.show('modalAtualizarDataVencimento'));
    },
    voltar() {
      window.history.back();
    },
    formataData(value) {
      if (!value) return '';
      return moment(value).format("DD/MM/YYYY");
    },
    formataDataBoleto(data) {
      if (!data) return '';
      return moment(data).format("DD/MM/YYYY");
    },
    async enviarBoletoWhatsapp(urlBoleto, vencimentoFatura ) {
      this.$store.dispatch('setLoading', true);
      let nrCelular = this.pedido.client.telefoneCelular;
      let dataFatura = moment(vencimentoFatura).format("DD-MM-YYYY");
      let empresa = this.empresa._id
      nrCelular = nrCelular.replace(/[() -]/gi, "");
      if (this.isAdministrador) {
        let resposta = {
          nrCelular:nrCelular,
          urlBoleto:urlBoleto,
          dataFatura:dataFatura,
          empresa:empresa
        }
        // eslint-disable-next-line
        console.log(resposta)
        const respostaEnvio = await axios.get("api/envioBoletoWhatsapp",{
          params:resposta
        })
        this.$store.dispatch('setLoading', false);
        if(respostaEnvio.status==200){
          this.$bvToast.toast(`Enviado com sucesso`, {
            title: 'Enviado por Boleto',
            variant: 'success',
            solid: true
          });
        }else{
          this.$bvToast.toast('Envio do boleto para o '+nrCelular+" não foi enviado", {
            title: respostaEnvio.data,
            variant: 'danger',
            solid: true
          });
        }
      }else{
        let msg = "Olá, segue o link do boleto para pagamento" + "\r\n\r\n" + urlBoleto;
        msg = window.encodeURIComponent(msg);

        let url = `https://api.whatsapp.com/send?phone=${nrCelular}&text=${msg}`;
        window.open(url);
        this.$store.dispatch('setLoading', false);
      }


    },
    traduzirStatusPagamento(fatura) {
      let statusVindi = fatura.statusFatura;
      switch (statusVindi) {
        case 'processing':
          return 'Processando pagamento';
        case 'failure':
          return 'Falha ao processar pagamento';
        case 'rejected':
          return 'Pagamento rejeitado';
        case 'success':
          return 'Pagamento Efetuado';
        case 'paid':
          return 'Pagamento Efetuado';
        case 'waiting_payment':
        case 'pending':
        case 'waiting':
          if (this.isVencida(fatura)) {
            return 'Vencida'
          }
          return 'Aguardando pagamento';
        case 'canceled':
          return 'Cancelado';
        default:
          return statusVindi;
      }
    },
    isVencida(fatura) {
      let dataVencimento = new Date(fatura.dataVencimento);
      return moment().isSameOrAfter(dataVencimento);
    },
    async atualizarDataVencimento(bvModalEvt) {
      bvModalEvt.preventDefault()
      try {
        await axios.post(`/api/saude/novaDataPagamentoFatura?idEmpresa=${this.empresa._id}`,{
          novaDataVencimento: this.dataVencimento,
          idCobranca: this.fatura.charge.id
        });
        this.$bvModal.hide('modalAlterarFormaPagamento');

        window.location.reload();

      } catch (error) {
        alert('Error' + error);
      } finally {
        this.dataVencimento = null;
        this.fatura = null;
      }
    },
    async enviarBoletoPorEmail(fatura) {
      try {
        this.$store.dispatch('setLoading', true);
        await axios.post(`/api/saude/fatura/send/email/${fatura.charge.id}?idEmpresa=${this.empresa._id}`);
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }finally {
        this.$store.dispatch('setLoading', false);
      }
    },
    async enviarCarnePorEmail() {
      try {
        this.$store.dispatch('setLoading', true);
        await axios.post(`/api/saude/fatura/send/carne/email/${this.pedido.idPedidoVindi}?idEmpresa=${this.empresa._id}`);
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    },
    async enviarCarnePorWhatsapp() {
      try {

        let nrCelular = this.pedido.client.telefoneCelular;
        nrCelular = nrCelular.replace(/[() -]/gi, "");
        nrCelular = "55" + nrCelular;

        let urlCarne = `${this.baseURL}/api/saude/fatura/build/carne/${this.pedido.idPedidoVindi}?idEmpresa=${this.empresa._id}`;
        if (this.isAdministrador) {
          let resposta = {
            nrCelular:nrCelular,
            urlCarne:urlCarne,
            nomeCliente:this.pedido.client.name
          }
          // eslint-disable-next-line
          console.log(resposta)
          const respostaEnvio = await axios.get("api/envioCarneWhatsapp",{
            params:resposta
          })
          this.$store.dispatch('setLoading', false);
          if(respostaEnvio.status==200){
            this.$bvToast.toast(`Enviado com sucesso`, {
              title: 'Enviado por Boleto',
              variant: 'success',
              solid: true
            });
          }else{
            this.$bvToast.toast('Envio do boleto para o '+nrCelular+" não foi enviado", {
              title: respostaEnvio.data ,
              variant: 'danger',
              solid: true
            });
          }
        }else{
          let msg = `Olá ${this.pedido.client.name}, segue link para impressão do seu Carnê:
              \r\n\n ${urlCarne}`;


          msg = window.encodeURIComponent(msg);

          let url = `https://api.whatsapp.com/send?phone=${nrCelular}&text=${msg}`;
          window.open(url);
          this.$store.dispatch('setLoading', false);
        }
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
    },
    getCharge(charges) {
      if (!charges) {
        return {}
      }
      if (charges.length == 1) {
        return charges[0];
      }

      return charges.find(charge => charge.status === 'pending' || charge.status === 'paid')
    }
  }
}
</script>

